import axios from 'axios';
import * as Sentry from '@sentry/react';
import Cookie from 'js-cookie';
import { ENIIG_UUID } from './cookies';

export const getEnv = (): 'dev' | 'qa' | 'staging' | 'prod' => {
    if (window.location.hostname.indexOf('localhost') !== -1) {
        return 'dev';
    } else if (window.location.hostname.indexOf('qa') !== -1) {
        return 'qa';
    } else if (window.location.hostname.indexOf('staging') !== -1) {
        return 'staging';
    } else {
        return 'prod';
    }
};

const getUUID = () => Cookie.get(ENIIG_UUID);

const sows = axios.create({
    baseURL: 'https://on6bpy8ldj.execute-api.eu-central-1.amazonaws.com/prod',
    // baseURL: 'http://localhost:4000/prod',
    params: {
        env: getEnv(),
        platform: 'stofa_privat_jlm',
    },
});

sows.interceptors.request.use((req) => {
    return { ...req, params: { ...req.params, uuid: getUUID() } };
});

sows.interceptors.response.use(
    (res) => res,
    (err) => {
        Sentry.captureException(err, { tags: { api: 'SOWS' } });
    }
);

export default sows;
